<template>
	<div v-if="!loading" id="landing-page" :style="pageStyle">
		<!--
        <a v-if="settings.fullscreen" id="fullscreen" @click="toggleFullscreen">
            <font-awesome-icon color="#414141" :icon="['fa', 'expand-alt']" />

            <pincode-dialog
                ref="pincodeDialog"
                :pincode="settings.fullscreenPin"
                @exit="$fullscreen.exit()"
            />
        </a>
		-->

		<module
			id="root"
			:data="root"
			:class="{
				raised: isRaised,
				angled: isAngled,
				shadow: isShadow,
				outlined: isOutlined,
			}"
			:style="rootStyle"
		>
			<module v-for="module in content" :key="module.id" :data="module" />
		</module>

		<expired-dialog
			v-if="$store.getters.expired"
			:title="settings.expireTitle"
			:text="settings.expireText"
		/>

		<!-- <snapchat-dialog v-if="showSnapchatWarning" /> -->
	</div>
</template>

<script>
import Vue from "vue";
import VueAnalytics from "vue-analytics";
import VueGtm from "vue-gtm";
import { VueReCaptcha } from "vue-recaptcha-v3";
import LoadScript from "vue-plugin-load-script";
import WebFontLoader from "webfontloader";

// import VueFullscreen from "vue-fullscreen";
// Vue.use(VueFullscreen);

import moment from "moment";

import Module from "./Module.vue";
import ExpiredDialog from "./dialogs/ExpiredDialog.vue";
//import TooEarlyDialog from "./dialogs/TooEarlyDialog.vue";
//import PincodeDialog from "./dialogs/PincodeDialog.vue";
//import SnapchatDialog from "./dialogs/SnapchatDialog.vue";

// Font map of Google fonts
const fontMap = {
	"Indie Flower": "Indie Flower",
	"Open Sans": "Open Sans",
	Roboto: "Roboto",
	"Roboto Condensed": "Roboto Condensed:400,700",
	Montserrat: "Montserrat",
	Oxygen: "Oxygen",
	Lobster: "Lobster",
	Bangers: "Bangers",
	Righteous: "Righteous",
	"Passion One": "Passion One",
	'"Sanchez", serif': "Sanchez",
	'"Pacifico", cursive': "Pacifico",
	'"Tillana", cursive': "Tillana",
	'"Mountains of Christmas", cursive': "Mountains of Christmas",
	'"Calligraffitti", cursive': "Calligraffitti",
	'"Covered By Your Grace", cursive': "Covered By Your Grace",
	'"Gloria Hallelujah", cursive': "Gloria Hallelujah",
	'"Leckerli One", cursive': "Leckerli One",
	'"Courgette", cursive': "Courgette",
	'"Yanone Kaffeesatz", sans-serif': "Yanone Kaffeesatz",
	'"Lato", sans-serif': "Lato",
	'"Rubik", sans-serif': "Rubik",
	'"Goldman", cursive': "Goldman",
	Ruda: "Ruda",
	'"Arimo", sans-serif': "Arimo",
	'"Secular One", sans-serif': "Secular One",
	'"Suez One", serif': "Suez One",
	'"Roboto", sans-serif': "Roboto:ital@1",
	'"Zilla Slab", sans-serif': "Zilla Slab",
};

export default {
	name: "LandingPage",
	components: {
		Module,
		ExpiredDialog,
		//TooEarlyDialog,
		//PincodeDialog,
		//SnapchatDialog,
	},
	data() {
		return {
			loading: true,
			root: null,
			content: null,
			settings: null,
			customer: null,
		};
	},
	computed: {
		pageStyle() {
			let style = {};

			if (this.settings.backgroundType == "color") {
				style = { backgroundColor: this.settings.background };
			} else if (this.settings.backgroundType == "image") {
				style = {
					backgroundImage: `url(${this.settings.background})`,
					backgroundRepeat: "repeat",
				};
			}

			style.fontFamily = this.settings.fontFamily;

			if (this.settings.fontFamily == '"Roboto", sans-serif')
				style.fontStyle = "italic";

			return style;
		},
		rootStyle() {
			return {
				"--box-shadow-color": this.root.layout.borderColor,
			};
		},
		isRaised() {
			return this.root.layout.borderLayout == "raised";
		},
		isAngled() {
			return this.root.layout.borderLayout == "angled";
		},
		isShadow() {
			return this.root.layout.borderLayout == "shadow";
		},
		isOutlined() {
			return this.root.layout.borderLayout == "outlined";
		},
		/* showSnapchatWarning() {
            return (
                this.$store.getters.pageId == 122 &&
                navigator.userAgent.indexOf("Snapchat") !== -1
            );
        }, */
	},
	methods: {
		setCustomCss() {
			let css = this.settings.customCSS;
			let head = document.getElementsByTagName("head")[0];

			let style = document.createElement("style");
			style.id = "custom_css";
			style.type = "text/css";
			style.innerHTML = css;
			head.appendChild(style);
		},
		setCustomJs() {
			let script = "";

			if (this.settings.customJs.startsWith("<script")) {
				script = document
					.createRange()
					.createContextualFragment(this.settings.customJs);
			} else {
				script = document.createElement("script");
				script.type = "text/javascript";
				script.text = this.settings.customJs;
				script.async = true;
				script.dataset.cfasync = false;
			}

			document.body.appendChild(script);
		},
		loadFacebookAPI() {
			Vue.use(LoadScript);

			Vue.loadScript("/js/facebookPixel.js").then(() => {
				window.fbq("init", this.settings.facebookPixel);

				window.fbq("track", "PageView", {
					content_name: "Landing Page Opened",
				});
			});
		},
		loadGoogleAnalytics() {
			Vue.use(VueAnalytics, {
				id: this.settings.googleAnalytics,
			});
		},
		loadGoogleTagManager() {
			// Fix for "LP stops loading when invalid GTM ID"
			try {
				Vue.use(VueGtm, {
					id: this.settings.googleTagManager,
					debug: true, // Whether or not display console logs debugs (optional)
					loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
				});
			} catch (err) {
				console.log(err);
			}
		},
		loadGoogleRecaptcha() {
			Vue.use(VueReCaptcha, {
				siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
				loaderOptions: {
					useRecaptchaNet: true,
				},
			});
		},
		checkExpiration(expireAt) {
			let current = moment.utc().format("yyyy-MM-DD HH:mm:ss");

			// Expired
			if (current > expireAt) this.$store.commit("SET_EXPIRED");
		},
		loadFont() {
			// Custom font for coca-cola
			if (
				this.settings.fontFamily == "HouseSlant" ||
				this.settings.fontFamily == "DinPro" ||
				this.settings.fontFamily == "GothamMedium"
			) {
				let fontCss = `/css/font-${this.settings.fontFamily.toLowerCase()}.css`;

				WebFontLoader.load({
					custom: {
						families: [this.settings.fontFamily],
						urls: [fontCss],
					},
				});
			} else if (this.settings.fontFamily in fontMap) {
				WebFontLoader.load({
					google: {
						families: [fontMap[this.settings.fontFamily]],
					},
				});
			}
		},
		/*toggleFullscreen() {
            if (this.$fullscreen.isFullscreen) {
                this.$refs.pincodeDialog.open(); // Show pincode to disable fullscreen
            } else {
                this.$fullscreen.toggle();
            }
        },*/
		loadAccessibility() {
			Vue.use(LoadScript);
			Vue.loadScript("https://code.jquery.com/jquery-3.7.0.min.js").then(
				() => {
					Vue.loadScript(
						"https://www.negishim.com/accessibility/accessibility_pro.js"
					);
					Vue.loadScript("/js/accessibility.js");
				}
			);
		},
		getFixedLandingPageCode() {
			// Check if a fixed landing page has been set up for the domain
			switch (window.location.host) {
				// Fixed landing page for Gas King Oil Co LTD. (20576)
				case "buypass.gasking.com":
					return "HRZELEfMTz";
			}
			return "";
		},
	},
	mounted() {
		// Get code from URL
		const path = location.pathname;
		let code = path.replace("/", "");

		if (code == "" && (code = this.getFixedLandingPageCode()) == "") return;

		this.$store
			.dispatch("load", code)
			.then(() => {
				this.root = this.$store.getters.root;
				this.content = this.$store.getters.content;
				this.settings = this.$store.getters.settings;

				// Load font
				this.loadFont();

				// Set i18n language
				this.$i18n.locale = this.settings.language;

				// Set document title
				document.title = this.settings.name;

				// Set custom favicon
				let favicon = document.getElementById("favicon");
				favicon.href = this.settings.favicon ?? "./favicon.ico";

				if (this.settings.googleAnalytics) this.loadGoogleAnalytics(); // Enable Google Analytics
				if (this.settings.googleTagManager) this.loadGoogleTagManager(); // Enable Google Recaptcha
				if (this.settings.googleRecaptcha) this.loadGoogleRecaptcha(); // Enable Google Recaptcha
				if (this.settings.facebookPixel) this.loadFacebookAPI(); // Enable Facebook Pixel
				if (this.settings.customCSS) this.setCustomCss(); // Add custom CSS
				if (this.settings.customJs) this.setCustomJs(); // Add custom Js
				if (this.settings.customFeatures.amir) this.loadAccessibility(); // Add accessibility
				// Check if expired
				if (this.settings.expire)
					this.checkExpiration(this.settings.expireAt);

				this.loading = false;
			})
			.catch((error) => {
				console.log(error);
			});
	},
	created() {
		// Prevent browser's back-forward cache
		window.onpageshow = function (event) {
			if (event.persisted) {
				window.location.reload();
			}
		};
	},
};
</script>

<style scoped>
#landing-page {
	margin: 0 auto;
	padding: 15px;
	min-height: 100%;
	min-width: 100%;
	box-sizing: border-box;
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;
	overflow: hidden;
}

#fullscreen {
	position: absolute;
	top: 10px;
	right: 10px;
}

#root {
	margin: auto;
	max-width: 500px;
	--box-shadow-color: palegoldenrod;
}

.angled {
	padding: 10px;
	border: 1px solid var(--box-shadow-color);
	box-shadow: -1px 1px var(--box-shadow-color),
		-2px 2px var(--box-shadow-color), -3px 3px var(--box-shadow-color),
		-4px 4px var(--box-shadow-color), -5px 5px var(--box-shadow-color);
}

.raised {
	box-shadow: 5px 8px var(--box-shadow-color);
}

.shadow {
	-webkit-box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.5);
	-moz-box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.5);
	box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.5);
}

.outlined {
	border: 2px solid var(--box-shadow-color);
}
</style>
